<template>
  <div id="app">
    <FinestHour/>
    <Squadron style="display: none"/>
    <notifications group="foo"
                   classes="my-notification-style"
                   :width="400"
                   :closeOnClick="true">
      <template slot="body" slot-scope="props">
        <div class="my-notification-style">
          <div class="body">
            <a class="title">
              {{props.item.title}}
            </a>
            <div v-html="props.item.text">
            </div>
          </div>
          <div class="action">
            <a class="close" @click="props.close">
              x
            </a>
          </div>
        </div>
      </template>
    </notifications>
  </div>
</template>

<script>
  import FinestHour from './components/FinestHour.vue';
  import Squadron from './components/Squadron.vue';

  export default {
    name: 'App',
    components: {
      FinestHour,
      Squadron,
    },
  };
</script>

<style lang="scss" rel="stylesheet/scss">
  @import "./vars";

  html {
    height: 100%;
    font-size: 62.5%;
    -webkit-font-smoothing: antialiased;
  }

  body {
    font-size: 1.3rem;
  }

  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    /*font-family: john-doe,sans-serif;*/
    /*font-weight: 400;*/
    /*font-style: normal;*/
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: $text-color;
  }

  .decorative-font {
    font-family: badaboom-pro, sans-serif;
    font-weight: 400;
    font-style: normal;
  }

  .typewriter-font {
    font-family: john-doe, sans-serif;
    font-weight: 400;
    font-style: normal;
  }

  .typewriter-font-bold {
    font-family: john-doe, sans-serif;
    font-weight: 700;
    font-style: normal;
  }

  .johndoe-font {
    font-family: john-doe, sans-serif;
    font-weight: 400;
    font-style: normal;
  }

  .johndoe-font-bold {
    font-family: john-doe, sans-serif;
    font-weight: 700;
    font-style: normal;
  }


  .typeka-font {
    font-family: typeka, sans-serif;
    font-weight: 400;
    font-style: normal;
  }

  .typeka-font-bold {
    font-family: typeka, sans-serif;
    font-weight: 700;
    font-style: normal;
  }

  .typeka-font-mix {
    font-family: typeka, sans-serif;
    font-weight: 500;
    font-style: normal;
  }

  .my-notification-style {
    font-family: typeka, sans-serif;
    padding: 1.6rem;
    border: solid 0.1rem #ddd;
    box-shadow: 0 0 1.6rem #00000066;
    overflow: visible;
    margin: 1.6rem;
    background: #fff;

    display: flex;

    .body{
      display: flex;
      flex-direction: column;
    }

    .action{
      font-size: 1rem;
      cursor: pointer;
    }

    .title {
      // Style for title line
      font-weight: 600;
      margin-bottom: 0.6rem;
    }

    .notification-content {
      // Style for content
    }

    &.my-type {
      /*
      Style for specific type of notification, will be applied when you
      call notification with "type" parameter:
      this.$notify({ type: 'my-type', message: 'Foo' })
      */
    }
  }

</style>
